import LinkCard from './components/LinkCard';

type LinkItem = {
  icon: string;
  label: string;
  subtitle?: string;
  to?: string;
  href?: string;
  external?: boolean;
  variant?: 'primary' | 'default';
};

const whatsappAtendente =
  'https://wa.me/5581981291168?text=Ol%C3%A1!%20Gostaria%20de%20agendar%20um%20hor%C3%A1rio%20para%20visitar%20o%20showroom%20da%20HomeOffice%20Premium.';

const links: LinkItem[] = [
  {
    icon: 'ri-whatsapp-line',
    label: 'Falar com atendente',
    subtitle: 'Agende seu horário para visitar o showroom',
    href: whatsappAtendente,
    external: true,
    variant: 'primary',
  },
  {
    icon: 'ri-global-line',
    label: 'Conhecer nosso site',
    subtitle: 'Veja tudo que oferecemos',
    to: '/',
  },
  {
    icon: 'ri-book-open-line',
    label: 'Ver catálogos',
    subtitle: 'Cadeiras, mesas, armários e mais',
    to: '/catalogos',
  },
  {
    icon: 'ri-shopping-cart-2-line',
    label: 'Catálogo interativo',
    subtitle: 'Cadastre-se, monte o carrinho e peça pelo WhatsApp',
    href: 'https://readdy.cc/preview/fcf5ab1e-d06e-40e9-9e86-c6d9d8062e00/13441890/auth',
    external: true,
  },
  {
    icon: 'ri-article-line',
    label: 'Blog',
    subtitle: 'Conteúdos sobre ambientes e mobiliário',
    to: '/blog',
  },
];

const extras: LinkItem[] = [
  {
    icon: 'ri-youtube-line',
    label: 'YouTube',
    subtitle: 'Vídeos e projetos',
    href: 'https://www.youtube.com/channel/UC3BsTtRw9BYTYosHOT0E_Ew',
    external: true,
  },
  {
    icon: 'ri-map-pin-line',
    label: 'Localização',
    subtitle: 'Av. Agamenon Magalhães, 1519 — Caruaru, PE',
    href: 'https://www.google.com/maps/search/?api=1&query=Av.+Agamenon+Magalh%C3%A3es%2C+1519%2C+Maur%C3%ADcio+de+Nassau%2C+Caruaru+-+PE',
    external: true,
  },
  {
    icon: 'ri-book-2-line',
    label: 'E-books gratuitos',
    subtitle: 'Guias para montar seu ambiente',
    to: '/ebooks',
  },
  {
    icon: 'ri-calculator-line',
    label: 'Calculadora de orçamento',
    subtitle: 'Estime seu investimento',
    to: '/calculadora',
  },
  {
    icon: 'ri-building-4-line',
    label: 'Projetos realizados',
    subtitle: 'Cases e entregas da HomeOffice',
    to: '/cases',
  },
  {
    icon: 'ri-presentation-line',
    label: 'Apresentação HomeOffice Premium 2026',
    subtitle: 'Nosso portfólio e soluções completas',
    href: '/media/docs/-4965-9f06-1763f35b4463_homeoffice_premium_apresentacao_atualizada.pdf',
    external: true,
  },
  {
    icon: 'ri-truck-line',
    label: 'Rastrear pedido',
    subtitle: 'Acompanhe sua entrega',
    to: '/rastreamento',
  },
  {
    icon: 'ri-heart-3-line',
    label: 'Caixinha de Ajuda',
    subtitle: 'Indique alguém que precisa de uma mão',
    to: '/caixinha-de-ajuda',
  },
];

const redes = [
  {
    icon: 'ri-instagram-line',
    href: 'https://www.instagram.com/homeoffice.premium/',
    label: 'Instagram',
  },
  {
    icon: 'ri-youtube-line',
    href: 'https://www.youtube.com/channel/UC3BsTtRw9BYTYosHOT0E_Ew',
    label: 'YouTube',
  },
  {
    icon: 'ri-whatsapp-line',
    href: whatsappAtendente,
    label: 'WhatsApp',
  },
];

export default function LinksPage() {
  return (
    <main className="min-h-screen bg-hop-bg-alt relative overflow-hidden">
      {/* Brilhos decorativos */}
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-hop-orange/10 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-[420px] h-[420px] bg-hop-orange/5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="relative max-w-xl mx-auto px-5 md:px-6 py-12 md:py-16">
        {/* Cabeçalho */}
        <header className="flex flex-col items-center text-center mb-8 md:mb-10 hop-fade-up">
          <div className="w-24 h-24 md:w-28 md:h-28 rounded-full bg-white border border-hop-border flex items-center justify-center p-3 mb-4">
            <img
              src="/media/marca/3e757d07-6a3c-4548-ad61-4bc647d9b031_vertical-cinza.png"
              alt="HomeOffice Premium"
              className="w-full h-full object-contain"
            />
          </div>
          <h1 className="text-2xl md:text-3xl font-extrabold text-hop-graphite tracking-tight">
            HomeOffice Premium
          </h1>
          <span className="inline-flex items-center gap-1.5 mt-3 bg-hop-orange/10 text-hop-orange text-xs md:text-sm font-semibold px-3 py-1.5 rounded-full">
            <i className="ri-map-pin-line text-xs"></i>
            Móveis corporativos · Caruaru, PE
          </span>
        </header>

        {/* Redes sociais */}
        <nav className="flex items-center justify-center gap-3 mb-8 md:mb-10 hop-fade-up" style={{ animationDelay: '80ms' }}>
          {redes.map((item) => (
            <a
              key={item.icon}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer nofollow"
              aria-label={item.label}
              className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-white border border-hop-border text-hop-graphite hover:border-hop-orange hover:text-hop-orange transition-all duration-200 cursor-pointer"
            >
              <i className={`${item.icon} text-lg md:text-xl`}></i>
            </a>
          ))}
        </nav>

        {/* Links principais */}
        <div className="flex flex-col gap-3">
          {links.map((link, i) => (
            <div key={link.label} className="hop-fade-up" style={{ animationDelay: `${140 + i * 60}ms` }}>
              <LinkCard {...link} />
            </div>
          ))}
        </div>

        {/* Separador */}
        <div className="flex items-center gap-3 my-8 hop-fade-up" style={{ animationDelay: '540ms' }}>
          <div className="flex-1 h-px bg-hop-border"></div>
          <span className="text-hop-text-secondary text-xs font-medium tracking-wide uppercase whitespace-nowrap">
            Explore também
          </span>
          <div className="flex-1 h-px bg-hop-border"></div>
        </div>

        {/* Links extras */}
        <div className="flex flex-col gap-3">
          {extras.map((link, i) => (
            <div key={link.label} className="hop-fade-up" style={{ animationDelay: `${600 + i * 60}ms` }}>
              <LinkCard {...link} />
            </div>
          ))}
        </div>

        {/* Rodapé */}
        <footer className="text-center mt-10 md:mt-12 hop-fade-up" style={{ animationDelay: '980ms' }}>
          <p className="text-hop-text-secondary text-xs font-light leading-relaxed">
            Especialistas em mobiliário corporativo, do projeto à montagem.
            <br />
            HomeOffice Premium — Caruaru, Pernambuco
          </p>
        </footer>
      </div>
    </main>
  );
}